/* eslint-disable max-len */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect, useCallback } from 'react';
import {
  ImageList as MuiImageList, ImageListItem, Box, Collapse, Button, IconButton,
} from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  Edit as EditIcon, Delete as DeleteIcon,
  VisibilityOff as VisibilityOffIcon, Visibility as VisibilityIcon,
} from '@mui/icons-material/';
import DeleteDialog from '../DeleteDialog';
import FileUploadDialog from './FileUploadDialog';
import { Image } from '../../atoms/Base';

export default function PublicImageList(props) {
  const {
    itemDatas, isEdit, onAddImg, onDelete, isNeedIntroduction, onChange, addLimitNumber,
    isNeedImageType, isNoTitle, noEdit, isNeedHidden, isDispIntroduction, isNeedOneLineIntroduction,
  } = props;
  const [hoverData, setHoverData] = useState({ hover: false, selectedId: null });
  const [open, setOpen] = useState(false);
  const [deleteData, setDeleteData] = useState({ open: false, selectedId: null });
  const [maxId, setMaxId] = useState(false);
  const [tempArray, setTempArray] = useState([]);
  const [selectItem, setSelectItem] = useState(null);

  useEffect(() => {
    if (itemDatas) {
      setTempArray([...itemDatas]);
    }
  }, [itemDatas]);

  const reorder = useCallback((list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }, []);

  const onDragEnd = useCallback((result) => {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    const arrays = reorder(
      tempArray,
      result.source.index,
      result.destination.index,
    );
    const updatedArrays = arrays.map((obj, index) => ({
      ...obj,
      displayOrder: index + 1,
    }));

    setTempArray(updatedArrays);
    onChange(updatedArrays);
  }, [tempArray, reorder, onChange]);

  const toggleHidden = useCallback((id) => {
    const updated = tempArray.map((it) => (it.id === id ? { ...it, hidden: !it.hidden } : it));

    setTempArray(updated);
    onChange(updated); // 親に通知（保存/更新は親で）
  }, [tempArray, onChange]);

  const imageListArea = () => (isEdit ? (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId="list"
        direction="horizontal"
      >
        {(provide) => (
          <MuiImageList
            sx={{ overflowY: 'hidden', overflowX: 'auto' }}
            cols={99}
            ref={provide.innerRef}
            {...provide.droppableProps}
          >
            {tempArray.map((item, index) => (

              <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={index}>
                {(provided) => (
                  <ImageListItem
                    key={item.id}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                    name={index}
                    sx={{
                      width: '200px',
                    }}
                  >
                    <Image src={item.isNew ? URL.createObjectURL(item[0]) : process.env.REACT_APP_AWS_PUBLIC_URL + item.imagePath} alt={item.title} mimeType={item.mimeType} />

                    <Collapse
                      in={hoverData.hover && hoverData.selectedId === item.id}
                      collapsedSize={40}
                      sx={{
                        minHeight: '50px',
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        cursor: isEdit ? 'pointer' : '',
                        bottom: 0,
                        color: '#fff',
                        width: '100%',
                        background: 'rgba(0, 0, 0, 0.5)',
                        padding: '5px',
                      }}
                      onMouseEnter={() => setHoverData({ hover: true, selectedId: item.id })}
                      onMouseLeave={() => setHoverData({ hover: false, selectedId: null })}
                    >
                      <Box>{item.title}</Box>
                      {isNeedOneLineIntroduction && (
                        <Box>{item.introduction}</Box>
                      )}
                    </Collapse>
                    {!noEdit && (
                      <IconButton
                        size="medium"
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: 30,
                          color: '#fff',
                        }}
                        onClick={() => { setOpen(true); setSelectItem(item); }}
                      >
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    )}
                    {!isNeedHidden && (
                      <IconButton
                        size="medium"
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          zIndex: 99,
                          color: '#fff',
                        }}
                        onClick={() => setDeleteData({ open: true, selectedId: item.id })}
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    )}
                    {isNeedHidden && (
                      <IconButton
                        size="medium"
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          zIndex: 99,
                          color: '#fff',
                        }}
                        onClick={() => toggleHidden(item.id)}
                      >
                        {item.hidden ? <VisibilityOffIcon fontSize="inherit" /> : <VisibilityIcon fontSize="inherit" />}
                      </IconButton>
                    )}
                  </ImageListItem>
                )}
              </Draggable>
            ))}
            {provide.placeholder}
          </MuiImageList>
        )}

      </Droppable>
    </DragDropContext>
  )
    : <StaticImageList items={tempArray} isDispIntroduction={isDispIntroduction} />);

  return (
    <>
      {isEdit && (!addLimitNumber || (addLimitNumber && tempArray.length < addLimitNumber)) && (
        <Box textAlign="right">
          <Button variant="contained" size="small" onClick={() => { setOpen(true); setSelectItem(null); setMaxId(tempArray.length > 0 ? Math.max(...itemDatas.map((item) => item.id)) + 1 : 1); }}>画像の追加</Button>
        </Box>
      )}
      {imageListArea()}
      <DeleteDialog
        open={deleteData.open}
        onClose={() => setDeleteData({ open: false, selectedId: null })}
        onDelete={() => {
          setDeleteData({ open: false, selectedId: null }); onDelete(deleteData.selectedId);
        }}
        procName="画像"
      />
      <FileUploadDialog
        isOpen={open}
        isNeedIntroduction={isNeedIntroduction}
        isNeedOneLineIntroduction={isNeedOneLineIntroduction}
        item={selectItem}
        newId={maxId}
        onClose={() => { setOpen(false); setSelectItem(null); }}
        onClick={(data) => { setOpen(false); onAddImg(data); setSelectItem(null); }}
        isNeedImageType={isNeedImageType}
        isNoTitle={isNoTitle}
      />
    </>
  );
}

function StaticImageList({ items, isDispIntroduction }) {
  return (
    <MuiImageList sx={{ overflowY: 'hidden' }} cols={3}>
      {items.map((item, index) => (
        <ImageListItem key={item.id} name={index}>
          {item.hidden && (
            <VisibilityOffIcon style={{ background: '#fff', position: 'absolute' }} />
          )}
          <Image src={item.isNew ? URL.createObjectURL(item[0]) : process.env.REACT_APP_AWS_PUBLIC_URL + item.imagePath} alt={item.title} mimeType={item.mimeType} />
          {(item.title && !item.mimeType.startsWith('video')) && (
            <Collapse
              in
              collapsedSize={40}
              sx={{
                minHeight: '50px',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                color: '#fff',
                width: '100%',
                background: 'rgba(0, 0, 0, 0.5)',
                padding: '5px',
              }}
            >
              <Box>{item.title}</Box>
            </Collapse>
          )}
          {isDispIntroduction && (
            <Box>{item.introduction}</Box>
          )}
        </ImageListItem>
      ))}
    </MuiImageList>
  );
}
